/** Toast / UI label for a parked-event duration in minutes. */
export function formatParkDurationLabel(durationMinutes: number): string {
  if (durationMinutes <= 0) {
    return 'Immediate';
  }
  if (durationMinutes === 1) {
    return '1 minute';
  }
  return `${durationMinutes} minutes`;
}
